import { useAtom } from 'jotai'

// helper functions
import { returnBlockValue } from '@/utils/op-types/helperFunctions'

// store
import { manifestBlocks, pageContentBlocks } from '@/utils/op-types/store'

const Block2Test = ({ block, design, content }) => {
  // manifest settings
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageBlocks] = useAtom(pageContentBlocks)

  return (
    <div className="pt-3 border border-gray-600 p-3 rounded mb-4">
      <div className="text-lg mb-3 font-bold">Repeatable Block...</div>

      {/* repeatable content example */}

      {returnBlockValue('benefits', 'content', opBlocks[block], content).map(
        (block, index) => (
          <div key={index} className="">
            {/* {JSON.stringify(block)} */}
            <h4>
              {block.number}: {block.text}
            </h4>
          </div>
        )
      )}
    </div>
  )
}

export default Block2Test
